/** The start of every id OpenCode gives a session. */
const OPENCODE_SESSION_ID_PREFIX = 'ses_';

/**
 * Whether the session runs on the person's own computer instead of in cubic's
 * cloud. Such a session keeps the id its OpenCode server gave it. A cloud
 * session's id never starts that way: `CodeSession.id` is a Postgres `uuid`
 * column, and the client's own pending rows use `creating` ids or
 * `crypto.randomUUID()`. A cloud session's `openCodeSessionId` does start that
 * way, and never reaches here. Everything that tells the two apart asks here:
 * `runtimeFor` and `codeRuntimeOf` for the runtime, `capabilitiesOf` for the
 * controls, `SessionFeed` for the live feed, the sidebar's mark of a session on
 * this computer, and the data layer's choice of the cached list and
 * environment reads a session has, in its create and its controller.
 */
export function isLocalSessionId(id: string): boolean {
  return id.startsWith(OPENCODE_SESSION_ID_PREFIX);
}
